﻿export enum ExternalLayerTypes {
    WMS = 1,
    WMTS = 2
}